<div class="container">
    <div class="row">
        <div class="channel-no" *ngIf="runningHourChannel?.opsData" [ngClass]="{ 'error-color': !isStatusSet }">
            <span class="tag" data-cy="running-hour-table-channel-no">{{ runningHourChannel.opsData.tag }}</span>
            <span class="name" data-cy="running-hour-table-channel-name">{{ runningHourChannel.opsData.name }}</span>
        </div>
        <div class="config-info-message" *ngIf="!isStatusSet">
            <mat-icon
                #infoIcon
                svgIcon="save-error"
                style="cursor: pointer; display: inline-block"
                (mouseenter)="openInfoMessage()"
                (mouseleave)="closeInfoMessage()"></mat-icon>
            <ng-container *ngIf="isInfoMessageVisible">
                <div
                    #infoMessageContainer
                    class="info-message-container"
                    [style.top.px]="infoTop"
                    [style.left.px]="infoLeft">
                    <div>
                        {{ 'running-hour-group.page.channels-without-configuration.message.part1' | translate }}
                    </div>
                    <br />
                    <div>
                        {{ 'running-hour-group.page.channels-without-configuration.message.part2' | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="row" [class.disabled]="!canEdit">
        <button
            class="text-button"
            data-cy="running-hour-table-select-channel-button"
            *ngIf="!dataSourceChannel"
            [disabled]="!canEdit"
            (click)="openSelectChannelDialog()">
            {{ 'running-hour-group.page.data-source.add-button' | translate }}
        </button>
        <button
            *ngIf="dataSourceChannel"
            class="text-button blue-background"
            data-cy="running-hour-table-data-source-channel-no-and-name"
            [disabled]="!canEdit"
            (click)="openSelectChannelDialog()">
            {{ getDataSourceName() }}
        </button>
        <button
            *ngIf="dataSourceChannel"
            class="clear-button-wrapper"
            [disabled]="!canEdit"
            (click)="removeChannelDialog()">
            <mat-icon svgIcon="delete" class="delete-icon icon-margin"> </mat-icon>
            <span class="clear-text remove-left-padding">
                {{ 'running-hour-group.page.status.clear' | translate }}
            </span>
        </button>
    </div>
    <div class="status-cell">
        <div
            class="input-wrapper"
            #dropdownWrapper
            [class.disabled]="!dataSourceChannel || !canEdit"
            [class.click-block]="!dataSourceChannel">
            <button
                mat-button
                #dropdownButton
                (click)="onToggleClick(); $event.stopPropagation()"
                [disabled]="!dataSourceChannel || !canEdit"
                class="status-dropdown"
                data-cy="running-hour-table-status"
                [class.bold]="isStatusSet">
                {{ selectedStatusLabel }}
                <mat-icon class="arrow" svgIcon="dropdown-arrow" [class.focus]="isDropdownOpen"> </mat-icon>
            </button>
            <button
                *ngIf="isStatusSet"
                class="clear-button-wrapper"
                (click)="resetStatusDialog()"
                [disabled]="!canEdit">
                <mat-icon svgIcon="delete" class="delete-icon icon-margin"> </mat-icon>
                <span class="clear-text remove-left-padding">
                    {{ 'running-hour-group.page.status.clear' | translate }}
                </span>
            </button>
        </div>
        <div *ngIf="isDropdownOpen" #dropdownContainer class="custom-dropdown-panel">
            <ng-container *ngIf="isDigitalChannel()" class="digital-status">
                <div
                    class="custom-menu-one-status-item"
                    data-cy="running-hour-table-status-item"
                    *ngFor="let status of dataSourceStatusesList"
                    (click)="onSelectSingleStatus(status); $event.stopPropagation()"
                    [class.selected]="selectedStatus === status">
                    {{ status || translate }}
                </div>
            </ng-container>
            <ng-container *ngIf="isMotorChannel()" class="dropdown-list">
                <div (click)="$event.stopPropagation()">
                    <div
                        class="custom-menu-checkbox-item"
                        *ngFor="let status of dataSourceStatusesList; let i = index"
                        (click)="toggleStatusByRowClick(status, i, $event)">
                        <mat-checkbox
                            class="custom-menu-checkbox-item"
                            [checked]="selectedMotorStatuses?.has(status)"
                            (change)="onToggleMotorStatus(status, i, $event.checked)">
                            {{ status || translate }}
                        </mat-checkbox>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<app-confirmation-window
    #removeDataSourceConfirmation
    [mainLabel]="'running-hour-group.table.remove.channel'"
    [discardLabel]="'running-hour-group.table.remove.channel.cancel'"
    [saveLabel]="'running-hour-group.table.remove.channel.save'"
    [allButtonsLeft]="true"
    [inverseColors]="true">
</app-confirmation-window>

<app-confirmation-window
    #resetStatusConfirmation
    [mainLabel]="'running-hour-group.table.reset.status'"
    [discardLabel]="'running-hour-group.table.reset.status.cancel'"
    [saveLabel]="'running-hour-group.table.reset.status.save'"
    [allButtonsLeft]="true"
    [inverseColors]="true">
</app-confirmation-window>
